<template>
  <header class="header">
    <div class="header-left">
      <MenuBurger />
      <span class="page-title">{{ title }}</span>
    </div>
    <div class="header-right">
      <div class="tenant" v-if="tenantName">
        <img src="@/assets/companyicon.svg" alt="Company" class="tenant-icon" />
        <span>{{ tenantName }}</span>
      </div>
      <div class="user" v-if="userName">
        <img src="@/assets/usericon.svg" alt="User" class="user-icon" />
        <span>{{ userName }}</span>
      </div>
    </div>
  </header>
</template>

<script>
import {ref, onMounted} from 'vue';
import MenuBurger from './MenuBurger.vue';

export default {
  name: 'AppHeader',
  components: {
    MenuBurger
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  setup() {
    const tenantName = ref('');
    const userName = ref('');

    onMounted(() => {
      // Get tenant info
      const tenant_id = localStorage.getItem('tenant_id');
      if (tenant_id) {
        // Map tenant_id to display name
        const tenantMap = {
          'watertech-dev': 'Watertech Dev',
          'watertech': 'Watertech'
        };
        tenantName.value = tenantMap[tenant_id] || tenant_id;
      }

      // Get user info
      try {
        const userInfoStr = localStorage.getItem('user_info');
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);

          // Check for lowercase first_name & last_name properties
          if (userInfo.first_name && userInfo.last_name) {
            userName.value = `${userInfo.first_name} ${userInfo.last_name}`;
          } else if (userInfo.firstName && userInfo.lastName) {
            // Try camelCase as fallback
            userName.value = `${userInfo.firstName} ${userInfo.lastName}`;
          } else if (userInfo.FirstName && userInfo.LastName) {
            // Try PascalCase as fallback
            userName.value = `${userInfo.FirstName} ${userInfo.LastName}`;
          } else {
            userName.value = userInfo.email || userInfo.Email || '';
          }
        }
      } catch (error) {
        console.error('Error parsing user info:', error);
      }
    });

    return {
      tenantName,
      userName
    };
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  height: 80px;
  margin-left: 30px !important;
  margin-right: 30px !important;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 24px;
}

.page-title {
  font-size: 11px;
  color: white;
  font-weight: 300;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  z-index: 1000 !important;
}

.header-right {
  display: flex !important;
  align-items: center !important;
  gap: 24px !important;
  z-index: 1000 !important;
}

.tenant,
.user {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-size: 11px;
  font-weight: 300;
  z-index: 1000;
}

.tenant-icon,
.user-icon {
  width: 15px;
  height: 15px;
}
</style>